<template><ArticlePage page="features" :content="content" /></template>
<script>
import ArticlePage from '@/components/ArticlePage.vue';
import content from '@/documents/content/features.js';
export default { name: 'Features', components: { ArticlePage }, data: () => ({ content }) };
</script>
